<template>
  <button @click="openSlideoutSearch">
    <slot />
  </button>
</template>

<script>
import { useSlideoutSearchStore } from '../pinia/SlideoutSearchStore'
import { mapActions } from 'pinia'

export default {
  methods: {
    ...mapActions(useSlideoutSearchStore, ['openSlideoutSearch'])
  },
}
</script>
